import React from "react";
import { CompletionLoader, DeveloperLoader, ImageLoader, LocationLoader, PriceLoader, TitleLoader } from "./LoaderCommon";

export default function ProjectLoader() {
    return (
        <div className="slider-card project-slider-card">
            <div className="slide-card-img">
                <ImageLoader />
            </div>
            <div className="heading_title">
                <TitleLoader />
            </div>
            <div className="developer">
                <DeveloperLoader />
            </div>
            <div className="location">
                <LocationLoader />
            </div>
            <div className="price">
                <PriceLoader />
            </div>
            <div className="flex items-center info_wrapper">
                <div className="item-summary">
                    <CompletionLoader />
                </div>
                <div className="item-summary">
                    <CompletionLoader />
                </div>
                <div className="item-summary">
                    <CompletionLoader />
                </div>
            </div>
        </div>
    );
}
